export const clientPortal = {
  extends: 'Page',
  flow: 'y',
  minHeight: '100vh',
  background: 'surface',

  // Top nav — light, minimal
  ClientNav: {
    tag: 'nav',
    flow: 'x',
    align: 'center space-between',
    padding: 'A C',
    borderBottom: '1px solid surfaceBorder',
    background: 'surfaceCard',
    FirmLogo: { text: '{{ portalFirmLogo | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'text' },
    ClientInfo: {
      flow: 'x', gap: 'Z', align: 'center',
      ClientName: { text: (el, s) => s.root.clientPortal.clientName, fontSize: 'Z', color: 'textSoft' },
      LogoutClientLink: { extends: 'Link', href: '/', text: '{{ portalLogout | polyglot }}', fontSize: 'Z', color: 'textMuted', textDecoration: 'none', onClick: (e, el, s) => s.root.update({ loggedIn: false }) },
    },
  },

  ClientContent: {
    flow: 'y',
    padding: 'C',
    gap: 'B',
    maxWidth: 'I',
    margin: '0 auto',
    width: '100%',
    '@mobileL': { padding: 'A' },

    WelcomeText: { tag: 'h1', text: (el, s) => '{{ portalWelcome | polyglot }} ' + s.root.clientPortal.clientName, fontSize: 'C', fontWeight: '800', color: 'text' },

    // Active cases
    CasesSection: {
      flow: 'y', gap: 'A',
      SectionTitle: { tag: 'h2', text: '{{ portalActiveCases | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'text' },
      CaseCard1: {
        flow: 'y', gap: 'A', padding: 'B', background: 'surfaceCard', border: '1px solid surfaceBorder', borderRadius: 'Z',
        CaseTop: {
          flow: 'x', align: 'center space-between',
          CaseNumType: { flow: 'x', gap: 'Z', align: 'center', CaseNum: { text: '#2024-047', fontSize: 'A', fontWeight: '600', color: 'text' }, CaseType: { tag: 'span', text: '{{ portalCaseTypeCivil | polyglot }}', padding: 'Y Z', background: 'blueBg', color: 'blue', border: '1px solid blueBorder', borderRadius: 'Z', fontSize: 'Z' } },
          CaseStatusChip: { extends: 'StatusActive', text: '{{ portalStatusActive | polyglot }}' },
        },
        ProgressBar: {
          flow: 'y', gap: 'Y',
          ProgressLabel: { text: '{{ portalProgressLabel | polyglot }}', fontSize: 'Z', color: 'textMuted' },
          ProgressTrack: { width: '100%', height: 'Y', background: 'surfaceBorder', borderRadius: 'Z', ProgressFill: { width: '60%', height: '100%', background: 'green', borderRadius: 'Z' } },
        },
        NextStep: { flow: 'x', gap: 'Y', align: 'center', StepIcon: { extends: 'Icon', icon: 'arrowRight', width: 'Z', height: 'Z', color: 'green' }, StepText: { text: '{{ portalNextHearing | polyglot }}', fontSize: 'Z', color: 'green', fontWeight: '500' } },
        UpdateDate: { text: '{{ portalLastUpdate | polyglot }}', fontSize: 'Z', color: 'textMuted' },
      },
    },

    // Pending invoices
    InvoicesSection: {
      flow: 'y', gap: 'A',
      SectionTitle: { tag: 'h2', text: '{{ portalPendingInvoices | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'text' },
      InvoiceCard: {
        flow: 'x', align: 'center space-between', padding: 'A', background: 'surfaceCard', border: '1px solid amberBorder', borderRadius: 'Z',
        InvLeft: {
          flow: 'y', gap: 'Y',
          InvNum: { text: 'INV-2024-031', fontSize: 'Z', color: 'textMuted' },
          InvAmount: { text: '₾1,200', fontSize: 'B', fontWeight: '700', color: 'text' },
          InvDue: { text: '{{ portalInvoiceDue | polyglot }}', fontSize: 'Z', color: 'amber' },
        },
        PayBtn: { extends: 'Button', text: '{{ portalPay | polyglot }}', theme: 'primary', padding: 'Z A', fontSize: 'Z', borderRadius: 'Z', cursor: 'pointer' },
      },
    },

    // Recent documents
    DocsSection: {
      flow: 'y', gap: 'A',
      SectionTitle: { tag: 'h2', text: '{{ portalDocuments | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'text' },
      DocRow1: {
        flow: 'x', align: 'center space-between', padding: 'Z A', background: 'surfaceCard', border: '1px solid surfaceBorder', borderRadius: 'Z',
        DocInfo: { flow: 'x', gap: 'Z', align: 'center', DocIcon: { extends: 'Icon', icon: 'document', width: 'A', height: 'A', color: 'textMuted' }, DocName: { text: '{{ portalDocName1 | polyglot }}', fontSize: 'Z', color: 'text' } },
        DocDate: { text: '{{ portalDocDate1 | polyglot }}', fontSize: 'Z', color: 'textMuted' },
      },
    },

    // Messages
    MessagesSection: {
      flow: 'y', gap: 'A',
      SectionTitle: { tag: 'h2', text: '{{ portalMessages | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'text' },
      MessagesList: {
        flow: 'y', gap: 'Z', padding: 'A', background: 'surfaceCard', border: '1px solid surfaceBorder', borderRadius: 'Z', minHeight: 'E',

        Msg1: {
          flow: 'y', gap: 'Y', padding: 'Z A', background: 'greenBg', borderRadius: 'Z', maxWidth: '80%',
          MsgFrom: { text: '{{ portalMsgFrom1 | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'green' },
          MsgText: { text: '{{ portalMsgText1 | polyglot }}', fontSize: 'Z', color: 'text', lineHeight: '1.5' },
          MsgTime: { text: '10:30', fontSize: 'Y', color: 'textMuted' },
        },
        Msg2: {
          flow: 'y', gap: 'Y', padding: 'Z A', background: 'surfaceBorder', borderRadius: 'Z', maxWidth: '80%', alignSelf: 'flex-end',
          MsgText: { text: '{{ portalMsgText2 | polyglot }}', fontSize: 'Z', color: 'text', lineHeight: '1.5' },
          MsgTime: { text: '10:45', fontSize: 'Y', color: 'textMuted', textAlign: 'right' },
        },
      },
      MessageInput: {
        flow: 'x', gap: 'Z',
        MsgInput: { tag: 'input', type: 'text', name: 'message', placeholder: '{{ portalMsgPlaceholder | polyglot }}', padding: 'Z A', fontSize: 'A', background: 'surfaceCard', border: '1px solid surfaceBorderStrong', borderRadius: 'Z', color: 'text', flex: '1' },
        SendMsgBtn: { extends: 'Button', text: '{{ portalSend | polyglot }}', theme: 'primary', padding: 'Z A', fontSize: 'Z', borderRadius: 'Z', cursor: 'pointer' },
      },
    },
  },
}
